export const RUN_STEP1X_REQUEST = 'RUN_STEP1X_REQUEST';
export const RUN_STEP1X_SUCCESS = 'RUN_STEP1X_SUCCESS'; 
export const RUN_STEP1X_FAILURE = 'RUN_STEP1X_FAILURE';